export default __webpack_public_path__ + "static/media/mw2.860caa6e.webp";